import script from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=6a543024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a543024"]])

export default __exports__